import React from "react";
import { Contact } from "../components/Forms/contactForm";
import { styles } from "../styles";
import { textVariant } from "../utils/motion";
import { motion } from "framer-motion";
export const ContactUs = () => {
  return (
    <div className="main-contactus">
      <div className="mt-10" />
      <Contact />
      <hr />
      <motion.div variants={textVariant()} className="">
        <div className="HeaderContactUs">
          <h2 className={`${styles.sectionHeadText} `}>Important Contacts</h2>
        </div>
      </motion.div>
      <div className="container-Contactus">
        <div className="cards-Contactus">
          <div className="card-Holder">
            <div className="card-contact1">
              <h2>MARKETING DEPARTMENT</h2>
              <div className="email-div">
                <h4>Email:-</h4>
                <ul>
                  <li>vishvaspower@gmail.com</li>
                  <li>director@vishvaspower.co.in</li>
                </ul>
              </div>
            </div>

            <div className="card-contact2">
              <h2>PURCHASE DEPARTMENT</h2>
              <div className="email-div">
                <h4>Email:-</h4>
                <ul>
                  <li>purchase@vishvaspower.co.in</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="card-Holder">
            <div className="card-contact1">
              <h2>SERVICE DEPARTMENT</h2>
              <div className="email-div">
                <h4>Email:-</h4>
                <ul>
                  <li>project@vishvaspower.co.in</li>
                </ul>
              </div>
            </div>

            <div className="card-contact2">
              <h2>HR DEPARTMENT</h2>
              <div className="email-div">
                <h4>Email:-</h4>
                <ul>
                  <li>hr@vishvaspower.com</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
